import { render, staticRenderFns } from "./PatrimonioInventarioAnualModal.vue?vue&type=template&id=2fe2f91c&scoped=true"
import script from "./PatrimonioInventarioAnualModal.vue?vue&type=script&lang=js"
export * from "./PatrimonioInventarioAnualModal.vue?vue&type=script&lang=js"
import style0 from "./PatrimonioInventarioAnualModal.vue?vue&type=style&index=0&id=2fe2f91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe2f91c",
  null
  
)

export default component.exports